export function checkboxColorContainer() {
  const checkboxList = document.querySelectorAll('.js-checkbox-label')
  checkboxList.forEach((element) => {
    const checkbox = element?.previousElementSibling
    const callback = () => {
      if (checkbox.checked) {
        checkbox.parentElement.classList.add('container__checkbox--checked')
      } else {
        checkbox.parentElement.classList.remove('container__checkbox--checked')
      }
    }
    element.addEventListener('click', callback)
    checkbox.addEventListener('click', callback)
  })
}
